import {Divider, IconButton, makeStyles, Popover, Tooltip} from '@material-ui/core';
import UtilService from "../../../helper/service";
import {CREATOR_TABLE_SUBHEADER} from "../../../config/mock";
import clsx from "clsx";
import {useCallback, useState} from "react";
import moment from 'moment';
import {exportExperiencesAsZip, initAnalysisData, updateClipedData} from "../../../store/actions/creator/analysis";
import {
  getSessionParticipantsSuccess,
  initLiveAnalysisData
} from "../../../store/actions/creator/creatorExperienceManager";
import roles from "../../../helper/roles";
import {useHistory} from "react-router";
import {useDispatch} from "react-redux";
import CustomCheckBox from "../../pages/creator/experienceManager/participantsDashboard/component/CustomCheckbox";
import OverviewClipDotMenu from "../../pages/creator/experienceManager/overview/clipdotmenu";
import {BackDropAnalyzeLoading} from "../commonLoadings";
import CustomizedSnackbars from "../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar";
import {useStylesTooltip} from "../../../config/theme";

const useStyles = makeStyles(() => ({
  popover: {
    width: '70vw',
    background: '#fff',
    borderRadius: 10
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0,
    '& p:first-of-type': {
      margin: '0 7px',
      fontSize: 18,
    },
    '& p:nth-of-type(2)': {
      fontFamily: 'Spartan-bold',
      letterSpacing: 1.2,
      paddingTop: 4,
      textTransform: 'uppercase',
    }
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
    '& img': {
      width: 12,
      height: 12,
      marginRight: 3
    }
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    color: '#8191A1',
    marginTop: 6
  },
  title: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14
  },
  header: {
    top: 0,
    position: 'sticky',
    background: 'white',
    zIndex: 1000,
    height: 60,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 12,
    borderBottom: '1px solid #D9D9D9',
    textTransform: 'uppercase',
    '& div': {
      textAlign: 'left'
    }
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    marginTop: 18,
    marginLeft: 5,
    padding: '3px 4px 3px 4px',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 10,
    background: '#F0F0F0',
    borderRadius: 6,
    textTransform: 'none',
    '&:hover': {
      background: '#e7e5e5',
    },
    '& img': {
      marginRight: 3
    }
  },
  label: {
    fontSize: 12,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textAlign: 'left',
  },
  icon: {
    width: 20,
    height: 20
  },
  pop: {
    maxHeight: '70%',
    '& .MuiPaper-rounded': {
      borderRadius: 20
    },
    '& .MuiPaper-elevation8': {
      top: '145px!important',
      left: '105px!important',
      boxShadow: '0px 0px 10px #00000033'
    }
  },
  cursor: {
    cursor: 'pointer',
  },
  clipDiv: {
    display: 'flex',
    alignItems: 'center',
    height: 60,
    color: '#697683',
    fontSize: 14,
    borderBottom: '1px solid #00000015',
    cursor: 'pointer',
    '&:hover': {
      background: '#F2F7FC'
    }
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  clipsPanel: {
    overflowY: 'auto'
  },
  iconBtn: {
    width: 40,
    borderRadius: 10,
    background: 'transparent',
    '&:hover': {
      background: '#017AEF14'
    }
  },
}));

const OverviewTabClipsPopout = (props: any) => {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const history = useHistory();
  const dispatch = useDispatch();
  const tooltipClasses = useStylesTooltip();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const { clips, session, anchorEl, setAnchorEl } = props;
  const [selectedClips, setSelectedClips] = useState<any[]>([]);
  const [downloading, setDownloading] = useState(false);
  const [messageType, setMessageType] = useState("success");
  const [message, setMessage] = useState('');
  const [isOpenMessage, setIsOpenMessage] = useState(false);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getStartClip = useCallback((clipStart: any) => {
    if (session) {
      const {session_trim_from, started_at, scheduled_start_at} = session;
      const experienceStart = started_at ? started_at : scheduled_start_at;
      return clipStart - (session_trim_from ? session_trim_from : experienceStart)
    }
    return 0;
  }, [session]);

  const getEndClip = useCallback((clipEnd: any) => {
    if (session) {
      const {session_trim_from, started_at, scheduled_start_at} = session;
      const experienceStart = started_at ? started_at : scheduled_start_at;
      return clipEnd - (session_trim_from ? session_trim_from : experienceStart);
    }
    return 0;
  }, [session]);

  const onShowClip = (clip: any) => {
    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(clip.session_code));
    localStorage.setItem("session_id", String(clip.session_id));
    localStorage.setItem("session_name", String(session.session_title));
    let url = `/creator/experience-manager/analyze/${clip.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/analyze/${clip.session_code}`;
    }
    history.push(url, {session_id: clip.session_id});

    setTimeout(() => {

      dispatch(updateClipedData({
        title: clip.name,
        start_clip: clip.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(clip.start, false)/15 : clip.start,
        end_clip: clip.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(clip.end, true)/15 : clip.end,
        clip_id: clip.clip_id,
        score: {
          immersion: {
            immersion_index: clip.immersion,
            tier_indicator: clip.immersion_tier_indicator,
            color_indicator: clip.immersion_color_indicator,
            context_indicator: clip.immersion_context_indicator,
          },
          safety: {
            safety_index: clip.safety,
            tier_indicator: clip.safety_tier_indicator,
            color_indicator: clip.safety_color_indicator,
            context_indicator: clip.safety_context_indicator,
          }
        },
        length: clip.length,
        session_code: clip.session_code,
        session_id: clip.session_id,
        session_status: clip.session_status,
        session_title: clip.session_title,
        session_type: clip.session_type,
        img: clip.img,
        start: clip.start,
        end: clip.end
      }))
    }, 2000);
  };

  const onSelectAll = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedClips(clips);
      return;
    }
    setSelectedClips([]);
  }, [clips]);

  const handleClipCheck = useCallback(({}, clip: any) => {
    const _clip = selectedClips.find((c: any) => c.clip_id === clip.clip_id);
    if (_clip) {
      const newSelectedClips = selectedClips.filter((c: any) => c.clip_id !== clip.clip_id);
      setSelectedClips(newSelectedClips);
    } else {
      const originalClips = [...selectedClips];
      originalClips.push(clip);
      setSelectedClips(originalClips);
    }
  }, [selectedClips]);

  const isClipChecked = useCallback((clip_id: string) => {
    const selectedClip = selectedClips.find((c: any) => c.clip_id === clip_id);
    return !!selectedClip;
  }, [selectedClips]);

  const onExportClip = (clip: any) => {
    setDownloading(true);
    const request = {
      clips: [
        {session_code: clip.session_code, clip_ids: [clip.clip_id]}
      ]
    };

    onDownloadClipsData(request);
  };

  const onExportSelectedClips = useCallback(() => {
    setDownloading(true);
    const clips = UtilService.getClipsRequest(selectedClips);
    const request = { clips };

    onDownloadClipsData(request);
  }, [selectedClips]);

  const onDownloadClipsData = (request: any) => {
    dispatch(exportExperiencesAsZip(loginUserData.customer_id, request, (res: any) => {
      if (res) {
        downloadXLSXData(res);
      } else {
        showErrorMsg();
      }
    }))
  };

  const downloadXLSXData = (export_url: string) => {
    const a = document.createElement('a');
    a.href = export_url;
    a.download = 'download.xlsx';
    a.click();
    setDownloading(false);
    setSelectedClips([]);
  };

  const showErrorMsg = () => {
    setDownloading(false);
    setMessageType("error");
    setIsOpenMessage(true);
    setMessage('Cannot download XLSX file!');
    setSelectedClips([]);
  };

  const onClose = () => {
    setMessage('');
    setIsOpenMessage(false);
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      style={{ zIndex: 5 }}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      className={classes.pop}
    >
      <BackDropAnalyzeLoading loading={downloading} />

      <CustomizedSnackbars
        type={messageType}
        message={message}
        open={isOpenMessage}
        onClose={onClose}
      />

      <div className={classes.popover}>
        <div className={classes.header}>
          {CREATOR_TABLE_SUBHEADER.map((item: any, index: number) => (
            index === 0 ? (
              <div style={{ width: item.width }} key={index}>
                <CustomCheckBox
                  checked={clips && clips.length > 0 && selectedClips.length === clips.length}
                  onChange={onSelectAll}
                />
              </div>
            ) : (
              <div
                key={index}
                style={{ width: item.width, textAlign: index === 7 ? 'center' : 'unset' }}
                className={clsx(classes.cursor)}
              >
                { (index === 7 && selectedClips.length > 0) ? (
                  <Tooltip classes={tooltipClasses} title="Export Clips Data" placement="bottom" arrow>
                    <IconButton
                      className={classes.iconBtn}
                      size='small'
                      onClick={onExportSelectedClips}
                    >
                      <img src={'/assets/icons/download_icon.svg'} alt='img' />
                    </IconButton>
                  </Tooltip>
                ) : item.title}
              </div>
            )
          ))}
        </div>

        <Divider />

        <div className={classes.clipsPanel}>
          {clips && clips.map((clip: any, index: number) => (
            <div className={classes.clipDiv} key={index}>

              <div style={{ width: CREATOR_TABLE_SUBHEADER[0].width }}>
                <CustomCheckBox
                  key={clip.clip_id}
                  checked={isClipChecked(clip.clip_id)}
                  onClick={(event: any) => handleClipCheck(event, clip)}
                  inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                />
              </div>

              <div className={classes.left} style={{ width: CREATOR_TABLE_SUBHEADER[1].width }} onClick={() => onShowClip(clip)}>
                <img src={'/assets/icons/dashboard/scissors.svg'} alt={'img'} style={{ marginRight: 8 }} />
                { clip.name }
              </div>

              <div
                onClick={() => onShowClip(clip)}
                className={classes.healthyText}
                style={{ width: CREATOR_TABLE_SUBHEADER[2].width, color: UtilService.refactorGraphColor(clip.immersion_color_indicator) }}
              >
                {clip.immersion}
              </div>

              <div
                onClick={() => onShowClip(clip)}
                className={classes.healthyText}
                style={{ width: CREATOR_TABLE_SUBHEADER[3].width, color: UtilService.refactorGraphColor(clip.safety_color_indicator) }}
              >
                { clip.safety === 1 ? '-' : clip.safety }
              </div>

              <div style={{ width: CREATOR_TABLE_SUBHEADER[4].width, textTransform: 'lowercase' }} onClick={() => onShowClip(clip)}>
                {clip.length}
              </div>

              <div style={{ width: CREATOR_TABLE_SUBHEADER[5].width }} onClick={() => onShowClip(clip)}>
                {clip.session_type === 'MODERATED'
                  ? UtilService.secondsToHms(getStartClip(clip.start) > 0 ? getStartClip(clip.start) : 0)
                  : ((typeof clip.start === 'number') ? moment(clip.start * 1000).format('HH:mm:ss') : clip.start)}
              </div>

              <div style={{ width: CREATOR_TABLE_SUBHEADER[6].width }} onClick={() => onShowClip(clip)}>
                {clip.session_type === 'MODERATED'
                  ? UtilService.secondsToHms(getEndClip(clip.end) > 0 ? getEndClip(clip.end) : 0)
                  : ((typeof clip.end === 'number') ? moment(clip.end * 1000).format('HH:mm:ss') : clip.end)}
              </div>

              <div style={{ width: CREATOR_TABLE_SUBHEADER[7].width, textAlign: 'center' }}>
                {selectedClips.length === 0 && (
                  <OverviewClipDotMenu onExport={() => onExportClip(clip)}/>
                )}
              </div>

            </div>
          ))}
        </div>
      </div>
    </Popover>

  );
};

export default OverviewTabClipsPopout;